import { Sort } from "@evergis/ui";

import { RootState } from "../reducers";
import { TableFilterState } from "../../modules/Table/types";
import { TableSelection, TableSpecialFilter, TableState } from "./types";
import { FeatureDcExtended } from "../selectFeatures/types";

export const getQueryTableData = ({ table }: RootState): TableState["queryData"] => table?.queryData;

export const getTableLayerId = ({ table }: RootState): string => table?.layerId;

export const getTableFilters = ({ table }: RootState): Record<string, TableFilterState> => table?.tableFilters;

export const getTableFilterConditions = ({ table }: RootState): Record<string, string> => table?.tableFilterConditions;

export const getTableSelection = ({ table }: RootState): Record<string, TableSelection> => table?.tableSelection;

export const getTableSort = ({ table }: RootState): Record<string, Sort> => table?.tableSort;

export const getSpecialFilter = ({ table }: RootState): TableSpecialFilter => table?.specialFilter;

export const getTableSelectedFeature = ({ table }: RootState): FeatureDcExtended => table?.selectedFeature;
